type Emoji = {
  unicode: string;
  regex: RegExp;
};

type EmojifyOptions = {
  careful?: boolean;
};

const makeEmoji = (unicode: string, regexString: string): Emoji => ({
  unicode,
  regex: new RegExp(regexString, "g")
});

const emojis: Emoji[] = [
  makeEmoji("\ud83d\ude20", ">:-\\("),
  makeEmoji("\ud83d\ude20", ">:\\("),
  makeEmoji("\ud83d\ude20", ":angry:"),
  makeEmoji("\ud83d\ude03", ":-\\)"),
  makeEmoji("\ud83d\ude03", ":\\)"),
  makeEmoji("\ud83d\ude03", ":-D"),
  makeEmoji("\ud83d\ude03", ":D"),
  makeEmoji("\ud83d\ude03", ":smile:"),
  makeEmoji("\ud83d\ude1e", ":-\\("),
  makeEmoji("\ud83d\ude1e", ":\\("),
  makeEmoji("\ud83d\ude1e", ":disappointed:"),
  makeEmoji("\ud83d\ude1b", ":-P"),
  makeEmoji("\ud83d\ude1b", ":P"),
  makeEmoji("\ud83d\ude1b", ":tongue:"),
  makeEmoji("\ud83d\udc4d", ":thumbsup:"),
  makeEmoji("\ud83d\udc4e", ":thumbsdown:")
];

const getUnicode = (emoji: Emoji, options: EmojifyOptions = {}): string => {
  if (options.careful) {
    return ` ${emoji.unicode} `;
  } else {
    return `${emoji.unicode} `;
  }
};

export const emojify = (text: string, options: EmojifyOptions = {}): string => {
  let emojifiedText = text;
  emojis.forEach((emoji) => {
    emojifiedText = emojifiedText.replace(emoji.regex, getUnicode(emoji, options));
  });
  return emojifiedText;
};
